// surveyBrands.js
// Entirely fictional brand identities used to demo live survey re-skinning.
// Names are deliberately invented (not real companies) since this is a
// demonstration of theming range, not a claim of past client work.
// Each brand's visual treatment (color, typography, shape) is defined
// as CSS custom properties in src/scss/components/_surveyDemo.scss,
// keyed off the brand `id` via a `[data-brand="..."]` attribute selector.
export const surveyBrands = [
  {
    id: 'hollowridge',
    name: 'Hollowridge Outfitters',
    tagline: 'Outdoor & Lifestyle Goods',
    wordmark: 'Hollowridge',
    // Rating scales render as one connected strip, rounded only at the
    // outer ends, rather than as individually separated buttons.
    segmentedScale: true,
  },
  {
    id: 'nimbus-and-sage',
    name: 'Nimbus & Sage',
    tagline: 'Mindfulness & Wellness',
    wordmark: 'nimbus',
  },
  {
    id: 'cinderwave-audio',
    name: 'Cinderwave Audio',
    tagline: 'Consumer Electronics',
    wordmark: 'CINDERWAVE⚡',
    // No manual Back/Next — selecting a rating answer advances automatically.
    autoAdvance: true,
    hideNavButtons: true,
  },
];
